import React from 'react';
import { IssueAlert } from '../types/dashboard';
import Badge from './Badge';

interface IssueAlertCardProps {
  alert: IssueAlert;
  onClick?: () => void;
}

const IssueAlertCard: React.FC<IssueAlertCardProps> = ({ alert, onClick }) => {
  const severityClasses = {
    critical: 'border-red-500 dark:border-red-600 bg-red-50 dark:bg-red-900/20 text-red-900 dark:text-red-100',
    warning: 'border-amber-500 dark:border-amber-600 bg-amber-50 dark:bg-amber-900/20 text-amber-900 dark:text-amber-100',
    info: 'border-blue-500 dark:border-blue-600 bg-blue-50 dark:bg-blue-900/20 text-blue-900 dark:text-blue-100'
  };

  const badgeVariant = {
    critical: 'danger' as const,
    warning: 'warning' as const,
    info: 'info' as const
  };

  const cursorClass = onClick ? 'cursor-pointer hover:shadow-lg transition-shadow' : '';

  return (
    <div
      className={`border-2 rounded-lg p-4 ${severityClasses[alert.severity]} ${cursorClass}`}
      onClick={onClick}
    >
      <div className="flex items-center justify-between mb-2">
        <h4 className="font-semibold">{alert.label}</h4>
        <Badge 
          variant={badgeVariant[alert.severity]} 
          size="md"
          customColor={alert.severity === 'critical' ? '#ef4444' : alert.severity === 'warning' ? '#f59e0b' : '#3b82f6'}
        >
          {alert.count}
        </Badge>
      </div>
      <p className="text-sm opacity-80">Click to view details</p>
    </div>
  );
};

export default IssueAlertCard;
